import { type SceneData, SceneType } from '@types';
import { getLibMatrixData, getLibPanoData } from '@apis/mediaApis';

export async function getSceneMapLocation(
  sceneData: SceneData
): Promise<{ lng: number; lat: number; zoom?: number } | null> {
  const { materialId, type } = sceneData;
  try {
    let json = '';
    if (type === SceneType.pano) {
      const data = await getLibPanoData(materialId);
      json = data.mapLocation;
    } else if (type === SceneType.matrix) {
      const data = await getLibMatrixData(materialId);
      json = data.mapLocation;
    }
    let { lng, lat, zoom } = JSON.parse(json);
    lng = Number(lng);
    lat = Number(lat);
    zoom = Number(zoom);
    if (!lng || !lat) return null;
    return {
      lng,
      lat,
      ...(zoom && { zoom: Number(zoom) }),
    };
  } catch (e) {
    return null;
  }
}
